// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e330b00c","227":"4653c116"}[chunkId] + ".chunk.js";
};